import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from 'seagull';
import { DefaultValuePopover } from '~/components/AgreementStudioPage/TemplateVariables/DefaultValuePopover/DefaultValuePopover';
import { useTextFieldVariableIntegration } from '~/components/AgreementStudioPage/TemplateVariables/hooks/useTextFieldVariableIntegration';
import { useTemplateVariables } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariablesContext';
import { VariableFieldAdornment } from '~/components/AgreementStudioPage/TemplateVariables/VariableFieldAdornment/VariableFieldAdornment';
import { VariablePickerPopover } from '~/components/AgreementStudioPage/TemplateVariables/VariablePickerPopover/VariablePickerPopover';
import { VariablePreviewLine } from '~/components/AgreementStudioPage/TemplateVariables/VariablePreviewLine/VariablePreviewLine';
import { useLocaleKeys } from '~/i18n';
import { serviceModel } from '~/models';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
export default function ServiceNameTextField(param) {
    let { testId, disabled = false, serviceNameBlacklist } = param;
    const { t } = useLocaleKeys();
    const { control, watch, setValue } = useFormContext();
    const isBundle = Boolean(watch('bundle'));
    const inputRef = useRef(null);
    const watchedServiceName = watch('serviceName');
    const { showVariableErrors, unresolvedCustomVariables } = useTemplateVariables();
    const hasUnresolvedTags = showVariableErrors && unresolvedCustomVariables.some((label)=>watchedServiceName.includes("{{".concat(label, "}}")));
    const setServiceNameField = useCallback((newValue)=>setValue('serviceName', newValue), [
        setValue
    ]);
    const { enabled, inputProps, adornmentRef, adornmentStyle, fieldAdornmentProps, resolvedValues, pickerPopoverProps, defaultValuePopoverProps } = useTextFieldVariableIntegration(inputRef, setServiceNameField, {
        disabled
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "serviceName",
                rules: {
                    validate: (n)=>serviceModel.validateName(n, {
                            nameBlacklist: serviceNameBlacklist,
                            isBundleName: isBundle
                        })
                },
                render: (renderProps)=>{
                    const connected = connectControllerToTextField(renderProps);
                    const rhfRef = connected.inputRef;
                    return /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, connected), {
                                error: connected.error || hasUnresolvedTags,
                                helperText: hasUnresolvedTags ? t.components.templateVariables.section.fieldHelperText() : connected.helperText,
                                inputRef: (el)=>{
                                    inputRef.current = el;
                                    if (typeof rhfRef === 'function') {
                                        rhfRef(el);
                                    }
                                },
                                inputProps: inputProps,
                                autoFocus: true,
                                disabled: disabled,
                                label: isBundle ? t.serviceBuilder.serviceName.bundleLabel() : t.billing.serviceName.label(),
                                testId: testId,
                                InputProps: enabled ? {
                                    endAdornment: /*#__PURE__*/ _jsx("span", {
                                        ref: adornmentRef,
                                        style: adornmentStyle,
                                        children: /*#__PURE__*/ _jsx(VariableFieldAdornment, _object_spread({}, fieldAdornmentProps))
                                    })
                                } : undefined
                            })),
                            enabled && /*#__PURE__*/ _jsx(VariablePreviewLine, {
                                text: watchedServiceName,
                                resolvedValues: resolvedValues
                            })
                        ]
                    });
                }
            }),
            enabled && /*#__PURE__*/ _jsx(VariablePickerPopover, _object_spread({}, pickerPopoverProps)),
            enabled && /*#__PURE__*/ _jsx(DefaultValuePopover, _object_spread({}, defaultValuePopoverProps))
        ]
    });
}
